import * as ast from '../../generated/ast.js';
import { checkForDuplicateAndRequiredProperties, getId, } from '../../common/utilities.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateFileUploadJson(fileUploadJson, accept) {
    // Get the parent Node to which this belongs. The full path to that is
    // FileUploadJson => RichAssetFileUpload => RichAsset => Node
    const parentNode = fileUploadJson.$container?.$container
        ?.$container;
    const idField = getId(parentNode);
    const typeProperty = fileUploadJson.properties.find((prop) => {
        return ast.isFileUploadTypeProperty(prop);
    });
    if (!typeProperty) {
        accept('error', `Missing required property 'type'.`, {
            node: fileUploadJson,
            data: {
                id: idField?.id?.value,
                nodeNumber: parentNode?.name,
                propertyName: FRONTEND_PROPERTY_NAME.RICH_ASSET_CONTENT,
            },
        });
    }
    else if (typeProperty?.type === 'direct_post') {
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: fileUploadJson,
            allProperties: fileUploadJson.properties,
            requiredProperties: [
                ast.FileUploadTypeProperty,
                ast.UploadLabelProperty,
                ast.CancelLabelProperty,
                ast.HeadersProperty,
                ast.EndpointProperty,
            ],
            parentNode,
            accept,
        });
    }
    else if (typeProperty?.type === 'action_node') {
        // Check for duplicate and required properties
        checkForDuplicateAndRequiredProperties({
            node: fileUploadJson,
            allProperties: fileUploadJson.properties,
            requiredProperties: [
                ast.FileUploadTypeProperty,
                ast.UploadLabelProperty,
                ast.CancelLabelProperty,
                ast.ActionScriptProperty,
            ],
            parentNode,
            accept,
        });
    }
}
//# sourceMappingURL=file-upload.js.map